import React from 'react';
import styles from './FeedFilters.module.css';

type FilterValue = 'all' | 'wager' | 'entity' | 'project' | 'open' | 'active' | 'resolved';

type FeedFiltersProps = {
  readonly active: FilterValue;
  readonly onChange: (filter: FilterValue) => void;
};

const FILTERS: ReadonlyArray<{ readonly value: FilterValue; readonly label: string }> = [
  { value: 'all', label: 'All' },
  { value: 'wager', label: 'Wagers' },
  { value: 'open', label: 'Open Offers' },
  { value: 'active', label: 'Active' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'entity', label: 'Entities' },
  { value: 'project', label: 'Projects' },
];

const FeedFilters = ({ active, onChange }: FeedFiltersProps): React.ReactElement => (
  <div className={styles.filters}>
    {FILTERS.map((f) => (
      <button
        key={f.value}
        type="button"
        data-testid={`feedfilter-${f.value}`}
        aria-pressed={active === f.value}
        className={`${styles.chip}${active === f.value ? ` ${styles.active}` : ''}`}
        onClick={(): void => { onChange(f.value); }}
      >
        {f.label}
      </button>
    ))}
  </div>
);

export { FeedFilters };
export type { FilterValue };
